<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-miterlimit="10"
    stroke-width="1.5"
    aria-hidden="true"
    viewBox="0 0 25 25"
  >
    <path
      d="m18.128 13.978 1.061 1.062c.434.434.434 1.11 0 1.495-.434.434-1.11.434-1.495 0l-.724-.723"
    />
    <path
      d="m16.632 15.474 1.688 1.689c.435.434.435 1.11 0 1.495-.434.434-1.11.434-1.495 0l-1.689-1.688"
    />
    <path
      d="m14.702 16.536 1.785 1.785c.434.434.434 1.11 0 1.495-.434.435-1.11.435-1.496 0l-1.785-1.785M12.773 17.645l1.013 1.013c.434.434.386 1.11-.049 1.544-.434.434-1.158.434-1.543.048l-.772-.771M12.869 8.72l5.259 5.258M5.246 13.303.76 8.816l4.728-4.68 2.171 2.171s2.22-.579 4.439.049"
    />
    <path
      d="m11.856 17.5.048.049a1.05 1.05 0 0 1 0 1.447l-.965.965a1.05 1.05 0 0 1-1.447 0l-.049-.048a1.05 1.05 0 0 1 0-1.448l.965-.965c.386-.386 1.013-.386 1.448 0ZM10.505 15.57l.048.049a1.05 1.05 0 0 1 0 1.447l-1.351 1.351a1.05 1.05 0 0 1-1.448 0l-.048-.048a1.05 1.05 0 0 1 0-1.447l1.351-1.351c.386-.386 1.013-.386 1.447 0ZM7.465 12.58l.049.048a1.05 1.05 0 0 1 0 1.447l-1.351 1.351a1.05 1.05 0 0 1-1.448 0l-.048-.048a1.05 1.05 0 0 1 0-1.448l1.351-1.35a.967.967 0 0 1 1.447 0Z"
    />
    <path
      d="m9.25 13.785.049.049a1.05 1.05 0 0 1 0 1.447l-1.882 1.882a1.05 1.05 0 0 1-1.447 0l-.048-.049a1.05 1.05 0 0 1 0-1.447l1.881-1.882a1.05 1.05 0 0 1 1.448 0ZM17.838 13.303 23.241 7.9l-4.438-4.44-3.86 3.957s-2.557-1.785-4.004-.627c-.676.53-1.4.965-1.93 1.303a1.23 1.23 0 0 0-.482 1.543c.289.628 1.06.917 1.688.58l2.509-1.303"
    />
  </svg>
</template>
